









































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

export interface LoginPayload {
  dob: string;
  phone: string;
  publicId: string;
}

@Component
export default class PatientLoginView extends Vue {
  @Prop({ type: String, default: 'Medical Specialty Center' }) readonly officeName!: string;
  @Prop({ type: String, default: 'https://via.placeholder.com/150x50?text=Clinic+Logo' }) readonly officeLogo!: string;
  
  // Recibe errores de autenticación desde el padre
  @Prop({ type: String, default: '' }) readonly authError!: string;

  // Separate Date States
  private selectedYear: string = '';
  private selectedMonth: string = '';
  private selectedDay: string = '';

  // Form State
  private phone: string = '';
  private loading: boolean = false;
  private errorMessage: string = '';

  // Validation Errors State
  private errors: { dob?: string; phone?: string } = {};

  // WaitingMed Logo URL
  private wmLogoUrl: string = require('@/assets/wmpc_logo.svg');

  // Static Month List in English
  private monthsList = [
    { value: '01', label: 'Jan' },
    { value: '02', label: 'Feb' },
    { value: '03', label: 'Mar' },
    { value: '04', label: 'Apr' },
    { value: '05', label: 'May' },
    { value: '06', label: 'Jun' },
    { value: '07', label: 'Jul' },
    { value: '08', label: 'Aug' },
    { value: '09', label: 'Sep' },
    { value: '10', label: 'Oct' },
    { value: '11', label: 'Nov' },
    { value: '12', label: 'Dec' }
  ];

  // Observa si el componente padre le envía un error de autenticación
  @Watch('authError', { immediate: true })
  onAuthErrorChange(newError: string): void {
  if (newError) {
      this.errorMessage = newError;
      this.loading = false;
    }
  }

  get yearsList(): number[] {
    const currentYear = new Date().getFullYear();
    const years: number[] = [];
    for (let y = currentYear; y >= currentYear - 100; y--) {
      years.push(y);
    }
    return years;
  }

  get daysList(): string[] {
    if (!this.selectedYear || !this.selectedMonth) {
      return Array.from({ length: 31 }, (_, i) => String(i + 1).padStart(2, '0'));
    }

    const daysCount = new Date(Number(this.selectedYear), Number(this.selectedMonth), 0).getDate();
    return Array.from({ length: daysCount }, (_, i) => String(i + 1).padStart(2, '0'));
  }

  get formattedDob(): string {
    if (!this.selectedYear || !this.selectedMonth || !this.selectedDay) {
      return '';
    }
    return `${this.selectedYear}-${this.selectedMonth}-${this.selectedDay}`;
  }

  private validateForm(): boolean {
    this.errors = {};

    if (!this.selectedYear || !this.selectedMonth || !this.selectedDay) {
      this.errors.dob = 'Please select a complete date of birth.';
    }

    const rawPhone = this.phone.replace(/\D/g, '');
    if (!this.phone) {
      this.errors.phone = 'Phone number is required.';
    } else if (rawPhone.length < 10) {
      this.errors.phone = 'Please enter a valid 10-digit phone number.';
    }

    return Object.keys(this.errors).length === 0;
  }

  private formatPhone(e: Event): void {
    const input = e.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '');

    if (value.length > 10) {
      value = value.substring(0, 10);
    }

    if (value.length > 6) {
      this.phone = `(${value.substring(0, 3)}) ${value.substring(3, 6)}-${value.substring(6)}`;
    } else if (value.length > 3) {
      this.phone = `(${value.substring(0, 3)}) ${value.substring(3)}`;
    } else if (value.length > 0) {
      this.phone = `(${value}`;
    } else {
      this.phone = '';
    }
  }

  /**
   * Método público para detener el estado de carga y establecer mensaje de error
   */
  public setLoginError(message: string): void {
    this.loading = false;
    this.errorMessage = message;
  }

  async handleSubmit(): Promise<void> {
    if (!this.validateForm()) return;

    this.loading = true;
    this.errorMessage = '';

    const payload: LoginPayload = {
      dob: this.formattedDob,
      phone: this.phone,
      publicId: ''
    };

    this.$emit('submit-login', payload);
  }

  onLogoError(e: Event): void {
    const target = e.target as HTMLImageElement;
    target.src = 'https://via.placeholder.com/150x50?text=Clinic+Logo';
  }
}
